import React from "react";
import { Typography } from "@mui/material";

const CommentMention = ({ label }) => (
  <Typography
    component="span"
    sx={{
      color: "primary.main",
      fontWeight: 600,
      fontSize: "inherit",
    }}
  >
    @{label}
  </Typography>
);

export default CommentMention;
